export const CSRF_TOKEN_COOKIE_KEY = 'csrftoken';
